module.exports = __webpack_public_path__ + "static/omers-logo-b7e8f7cd2e8549c0190e53a48bdc9974.png";